import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { type UUID } from '~/types/common';

import { Icon } from '@vestigas/ui';

import { TaxCodeForm } from './TaxCodeForm';

type P = {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly taxCodeId?: UUID;
};

export function TaxCodeFormDialog({ isOpen, onClose, taxCodeId }: P) {
  const { t } = useTranslation('taxCodes');
  const isEditMode = Boolean(taxCodeId);

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      open={isOpen}
      onClose={onClose}
    >
      <DialogTitle className="flex items-center justify-between">
        {isEditMode ? t(($) => $.form.titleEdit) : t(($) => $.form.titleCreate)}
        <IconButton
          aria-label={t(($) => $.form.closeButton.ariaLabel)}
          size="small"
          onClick={onClose}
        >
          <Icon metaphor="close" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TaxCodeForm
          key={taxCodeId ?? 'new'}
          taxCodeId={taxCodeId}
          onCancel={onClose}
          onSuccess={onClose}
        />
      </DialogContent>
    </Dialog>
  );
}
